import { useId } from "react";
import { cn } from "@easytestdata/ui";

/**
 * The CopyMyBooks mark: the real books (outline, untouched) and the copy in front of them, with
 * ledger lines. The same drawing as public/favicon.svg, whose outline is thicker for 16 px.
 */
export function CopyMyBooksLogo({ className }: { className?: string }) {
  // One gradient id per instance: the header and the mobile menu can both draw the logo.
  const gradient = `cmb-${useId().replace(/:/g, "")}`;
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-10 w-10", className)}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#059669" />
          <stop offset="1" stopColor="#0891b2" />
        </linearGradient>
      </defs>
      <rect x="4" y="4" width="22" height="27" rx="4" stroke="#059669" strokeWidth="2.5" />
      <rect x="13" y="10" width="23" height="27" rx="4" fill={`url(#${gradient})`} />
      <rect x="18" y="17" width="13" height="2.6" rx="1.3" fill="#fff" />
      <rect x="18" y="22.2" width="9" height="2.6" rx="1.3" fill="#fff" opacity="0.85" />
      <rect x="18" y="27.4" width="13" height="2.6" rx="1.3" fill="#fff" />
    </svg>
  );
}
